module.exports = __webpack_public_path__ + "media/images/indicators/chuvaAgora-b7ec37f1d90efe31acc2014a31d166a5.png";